function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import mediaMin from '../styles/breakpoints';
import { themify } from '../styles/mixins';
import { containers } from '../styles/theme';
const StyledContainer = styled.div.withConfig({
  displayName: "Container__StyledContainer",
  componentId: "u7740q-0"
})(["position:relative;max-width:100%;margin-right:auto;margin-left:auto;background:", ";text-align:", ";width:100%;", "{width:", ";}"], x => x.$bgColor, x => x.$textAlign, mediaMin.md, x => x.$width);

const ContainerFunc = (_ref) => {
  let {
    bgColor = 'none',
    children,
    size = 'xl',
    textAlign = 'left'
  } = _ref,
      props = _objectWithoutProperties(_ref, ["bgColor", "children", "size", "textAlign"]);

  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    $bgColor: themify(bgColor),
    $textAlign: textAlign,
    $width: containers[size] || '100%'
  }, props), children);
};

export const Container = withSpacing(ContainerFunc);